import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { NavLink } from "react-router-dom";
import { Variables } from "../../Variations/Variations";
import { BiEdit, BiShowAlt, BiHide } from "react-icons/bi";
import { ToastContainer, toast } from "react-toastify";
import { AiOutlineClose, AiOutlineCheck, AiOutlineRight } from "react-icons/ai";

const AllWidgets = () => {
  const [widgets, setWidgets] = useState();
  const columns = [
    {
      name: "ID",
      selector: (row) => row.Id,
      sortable: true,
    },
    {
      name: "Widget Name",
      selector: (row) => row.Name,
      sortable: true,
    },
    {
      name: "Page Name",
      selector: (row) =>
        row.PageId === 1
          ? "Home"
          : row.PageId === 2
          ? "Beauty"
          : row.PageId === 3
          ? "Business"
          : "Living",
      sortable: true,
    },
    {
      name: "Published",
      selector: (row) =>
        row.IsPublished ? <AiOutlineCheck /> : <AiOutlineClose />,
      sortable: true,
    },

    {
      name: "Options",
      selector: (row) => (
        <div>
          <NavLink
            to={"/admin/rasha/Widgets/" + row.Id}
            className="btn btn-outline-secondary btn-sm"
          >
            <BiEdit />
          </NavLink>
          <button
            className="btn btn-outline-danger btn-sm ms-2"
            onClick={() => TooglePublishWidget(row.Id)}
          >
            {row.IsPublished ? <BiHide /> : <BiShowAlt />}{" "}
          </button>
        </div>
      ),
    },
  ];

  async function TooglePublishWidget(id) {
    let response = await fetch(
      Variables.API_URL + "Rasha/Widget/UpsertPublish/" + id,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": Variables.API_URL,
        },
      }
    );
    let result = await response.json();
    if (response.ok) {
      toast.success(result);
      GetWidgets();
    } else {
      toast.error(result);
    }
  }

  async function GetWidgets() {
    const URL = Variables.API_URL + "Rasha/Widget/Get";
    const response = await fetch(URL);
    if (!response.ok) throw Error("Did Not Receive expected data");
    const listItems = await response.json();

    setWidgets(listItems);
  }
  //#region Use Effect
  useEffect(() => {
    GetWidgets();
  }, []);
  //#endregion Use Effect
  return (
    <div className="rightSide">
      <div className="container-fluid mt-3">
        <div className="row">
          <div className="col-12">
            <h2>List Widgets</h2>
            <ul className="portalPath">
              <li>
                Home <AiOutlineRight />
              </li>
              <li>List Widgets</li>
            </ul>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <div className="col-12 mb-3 text-end">
                  <NavLink
                    to="/admin/rasha/Widgets/0"
                    className="btn btn-primary"
                  >
                    Add Widget
                  </NavLink>
                </div>
                <div className="portalTable">
                  <DataTable columns={columns} data={widgets} pagination />
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={true}
          newestOnTop={false}
          closeOnClick
        />
      </div>
    </div>
  );
};
export default AllWidgets;
